import { render, staticRenderFns } from "./RecapHorse.vue?vue&type=template&id=a8965896&"
import script from "./RecapHorse.vue?vue&type=script&lang=js&"
export * from "./RecapHorse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports